import { MenuData } from '../types';
import { normalizeMenuData } from './menuNormalize';

const makeKey = (userId: string, menuId?: string | null) => `menu_builder_draft:${userId}:${menuId || 'new'}`;

export const computeHash = (menu: MenuData): string => {
  try {
    const normalized = normalizeMenuData(menu);
    const payload = JSON.stringify(normalized);
    let hash = 0;
    for (let i = 0; i < payload.length; i++) {
      hash = (hash << 5) - hash + payload.charCodeAt(i);
      hash |= 0; // force 32-bit
    }
    return `${payload.length}:${hash}`;
  } catch {
    return '';
  }
};

export const loadDraft = (userId: string, menuId?: string | null): { menu: MenuData; hash: string; savedAt?: number } | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(makeKey(userId, menuId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const menu = normalizeMenuData(parsed?.menu || parsed);
    return { menu, hash: parsed?.hash || computeHash(menu), savedAt: parsed?.savedAt };
  } catch {
    return null;
  }
};

export const saveDraft = (userId: string, menuId: string | null | undefined, menu: MenuData) => {
  if (typeof window === 'undefined') return;
  try {
    const normalized = normalizeMenuData(menu);
    const hash = computeHash(normalized);
    const payload = { menu: normalized, hash, savedAt: Date.now() };
    window.localStorage.setItem(makeKey(userId, menuId), JSON.stringify(payload));
  } catch {
    // ignore write failures silently
  }
};

export const clearDraft = (userId: string, menuId?: string | null) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(makeKey(userId, menuId));
  } catch {
    // ignore
  }
};
